import { PageModule } from 'app/pages/types';
import React from 'react';
import ThirdPartyLogin from './ThirdPartyLogin';

export const ThirdPartyLoginPageModule: PageModule = {
  pageIf: (page, exception) => !exception && page === 'thirdpartylogin',
  render: () => <ThirdPartyLogin />
};
